import { 
  Checkmark20Filled,
  Warning20Filled,
} from '@fluentui/react-icons';

interface StatusBadgeOrcamentoProps {
  status: 'aceite' | 'recusado';
}

export function StatusBadgeOrcamento({ status }: StatusBadgeOrcamentoProps) {
  const isAceite = status === 'aceite';
  
  return (
    <div 
      className={`inline-flex items-center gap-2 px-4 py-3 border-2 ${
        isAceite 
          ? 'bg-[#10b981]/10 text-[#10b981] border-[#10b981]' 
          : 'bg-[#dc2626]/10 text-[#dc2626] border-[#dc2626]'
      }`}
      style={{ borderRadius: 'var(--radius-card)' }}
    >
      {isAceite ? (
        <Checkmark20Filled className="w-5 h-5" />
      ) : (
        <Warning20Filled className="w-5 h-5" />
      )}
      <span 
        style={{ 
          fontSize: 'var(--text-base)',
          fontWeight: 'var(--font-weight-semi-bold)'
        }}
      >
        {isAceite ? 'Orçamento Aceite' : 'Orçamento Recusado'}
      </span>
    </div>
  );
}
